import { axiosInstanceAuthorization } from '../Config/AxiosInterceptor';

const check = (): Promise<any> => {
  return axiosInstanceAuthorization.get(
    `${process.env.REACT_APP_BASE_URL}/api/v1/auth/check-user`,
  );
};

export default { check };
